<div class="cursor-pointer" [ngClass]="classes"
     #copyLinkTooltip="matTooltip" matTooltip="{{'labels.copied' | translate | titlecase}}"
     matTooltipPosition="right" matTooltipDisabled="true" (click)="onCopyLink(copyLinkTooltip)"></div>
